interface UserDisplayInput {
  userId: string | null | undefined
  fullName?: string | null | undefined
  email?: string | null | undefined
}

interface GetUserDisplayNameOptions {
  fallback?: string
}

export function getUserDisplayName(
  user: UserDisplayInput,
  currentUserId: string | null | undefined,
  options: GetUserDisplayNameOptions = {}
): string {
  const { fallback = 'Unknown' } = options
  if (currentUserId && user.userId && user.userId === currentUserId) {
    return 'You'
  }
  return user.fullName?.trim() || user.email?.trim() || fallback
}
